// extracted by mini-css-extract-plugin
module.exports = {"list":"h5_list__TM13q","triggerBtn":"h5_triggerBtn__aZT4H","card":"h5_card__CYA6w"};